// Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyC7z2bB7ATf91MMc-39DBPsUHTsFlGggkY",
  authDomain: "zamzi-connect.firebaseapp.com",
  projectId: "zamzi-connect",
  storageBucket: "zamzi-connect.firebasestorage.app",
  messagingSenderId: "888762995215",
  appId: "1:888762995215:web:959beebf5d0535dbae097a",
  measurementId: "G-Z248M7MT9H"
};
